import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeArrayProp, makeStringProp } from '@/utils';

const { name, bem } = createNamespaceBem('card-banner');

const cardBannerProps = {
  img: makeStringProp(''), // avatar
  title: makeStringProp(''), // 医生姓名
  titleTag: makeArrayProp<string>(), // 团队组长
  tags: makeArrayProp<string>(), // ['副主任医师', '皮肤科']
  bodyInfo: makeStringProp(''), // 个人介绍
  bodyInfoLabel: makeStringProp('团队介绍：'),
  footerData: makeArrayProp<{ label: string; data: number | string }>(), // 评分
};

export type CardBannerProps = ExtractPropTypes<typeof cardBannerProps>;

export default defineComponent({
  name,
  props: cardBannerProps,
  setup(props) {
    const renderTags = () => (
      <div class={bem('tags')}>
        {props.tags.map((i) => (
          <div class={bem('tag')}>{i}</div>
        ))}
      </div>
    );
    const renderFooter = () => (
      <div class={bem('footer-data')}>
        {props.footerData.map((i) => (
          <div class={bem('footer-data-item')}>
            <span>{i.data}</span>
            <span>{i.label}</span>
          </div>
        ))}
      </div>
    );
    return () => (
      <div class={bem()}>
        <div class={bem('title')}>
          <span class={bem('title-name')}>{props.title}</span>
          {props.titleTag.map((i) => (
            <span class={bem('title-tag')}>{i}</span>
          ))}
        </div>
        <img src={props.img} class={bem('img')} />
        {renderTags()}
        <div class={bem('info')}>
          {props.bodyInfoLabel}
          {props.bodyInfo}
        </div>
        {renderFooter()}
      </div>
    );
  },
});
